import { useAuth } from "@workos-inc/authkit-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const AuthPage = () => {
  const navigate = useNavigate();
  const { user, signIn } = useAuth();

  useEffect(() => {
    if (!user) {
      signIn();
    }
  }, [user, signIn]);

  if (user) {
    navigate("/");
  }

  return null;
};

export default AuthPage;
